import React, { Component } from 'react';
import { Grid, Tab, Table } from 'semantic-ui-react';

import BreadcrumbCustom from '../../layout/BreadcrumbCustom';

const panes = [
    {
        menuItem: 'A-C',
        render: () => {
            return (
                <Tab.Pane attached={false}>
                    <Table inverted celled className="grey">
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>A - C</Table.HeaderCell>
                                <Table.HeaderCell>Definition</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>#</Table.Cell>
                                <Table.Cell>Table Row Number</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Actions</Table.Cell>
                                <Table.Cell>Clickable Action Buttons</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Adjustment</Table.Cell>
                                <Table.Cell>Adjustment Amount</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Adjustment Date</Table.Cell>
                                <Table.Cell>Date Adjustment Made</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Adjustment Status</Table.Cell>
                                <Table.Cell>Is Adjustment Rejected/Approved/Pending</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Adjustment Type</Table.Cell>
                                <Table.Cell>Source of Adjustment (e.g. consumer, insurance, etc.)</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Agency</Table.Cell>
                                <Table.Cell>The Collection Agency</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>AR</Table.Cell>
                                <Table.Cell>Amount Referred</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Cancel Request Date</Table.Cell>
                                <Table.Cell>The Date of Cancellation Request</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Checkbox</Table.Cell>
                                <Table.Cell>Check to Include</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>City</Table.Cell>
                                <Table.Cell>Consumer’s City</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Client Acct#</Table.Cell>
                                <Table.Cell>Your Account Number for this Billing</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Client</Table.Cell>
                                <Table.Cell>Who the collection agency is collecting for</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Client ID or Client ID(s)</Table.Cell>
                                <Table.Cell>Our Client Identifier</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Consumer Name</Table.Cell>
                                <Table.Cell>Consumer’s First & Last Name</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Corporate Name</Table.Cell>
                                <Table.Cell>Parent Corporate Name</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Created Date</Table.Cell>
                                <Table.Cell>Date Role Created (User Roles screen)</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Created Date</Table.Cell>
                                <Table.Cell>Date Created</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Creator</Table.Cell>
                                <Table.Cell>Name of Role Creator (User Roles screen)</Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </Tab.Pane>
            );
        }
    },
    {
        menuItem: 'D-I',
        render: () => {
            return (
                <Tab.Pane attached={false}>
                    <Table inverted celled className="grey">
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>D - I</Table.HeaderCell>
                                <Table.HeaderCell>Definition</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>Date of Submission</Table.Cell>
                                <Table.Cell>Date Payment and/or Adjustment Submitted</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Delete</Table.Cell>
                                <Table.Cell>Accompanied by a checkbox to mark for deletion.</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Description</Table.Cell>
                                <Table.Cell>Description of the Saved Search Preferences [Reports / Inventory / Save Search Preferences]</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>DLP</Table.Cell>
                                <Table.Cell>Date of Last Payment</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>DOB</Table.Cell>
                                <Table.Cell>Consumer’s Date of Birth</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Doc Status</Table.Cell>
                                <Table.Cell>Status on Document Request</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Doc Type</Table.Cell>
                                <Table.Cell>Document Type Requested</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Docs</Table.Cell>
                                <Table.Cell>View Documents Needed</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>DOR</Table.Cell>
                                <Table.Cell>Date of Referral</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>DOS</Table.Cell>
                                <Table.Cell>Date of Service</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>End Date</Table.Cell>
                                <Table.Cell>The date to *end* the date range (For date ranges)</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Expand</Table.Cell>
                                <Table.Cell>View Account Details</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Finalized</Table.Cell>
                                <Table.Cell>Submitted to agency</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>First Name</Table.Cell>
                                <Table.Cell>Consumer’s First Name</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>For</Table.Cell>
                                <Table.Cell>Services Provided</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Hold Again</Table.Cell>
                                <Table.Cell>Hold Again Action</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Hold Request Date</Table.Cell>
                                <Table.Cell>Date Hold was Requested</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>INT</Table.Cell>
                                <Table.Cell>Interest</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>INTR</Table.Cell>
                                <Table.Cell>Interest Referred (Enter New Accounts screen)</Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </Tab.Pane>
            )
        }
    },
    {
        menuItem: 'L-P',
        render: () => {
            return (
                <Tab.Pane attached={false}>
                    <Table inverted celled className="grey">
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>L - P</Table.HeaderCell>
                                <Table.HeaderCell>Definition</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>Last Name</Table.Cell>
                                <Table.Cell>Consumer’s Last Name</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Lock Status</Table.Cell>
                                <Table.Cell>Has a lock been placed on the user’s account?</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Login Name</Table.Cell>
                                <Table.Cell>The User Name</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Name</Table.Cell>
                                <Table.Cell>Any Variation of Consumer’s Name (Table search only)</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>New Total</Table.Cell>
                                <Table.Cell>Total after Payment and/or Adjustment</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>NSF</Table.Cell>
                                <Table.Cell>Non-Sufficient Funds</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>OC</Table.Cell>
                                <Table.Cell>Other Charges</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>OCR</Table.Cell>
                                <Table.Cell>Other Charges Referred (Enter New Accounts screen)</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Our Acct#</Table.Cell>
                                <Table.Cell>Our Agency’s Account Number</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Patient</Table.Cell>
                                <Table.Cell>Name of Patient</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Pay Type</Table.Cell>
                                <Table.Cell>Source of Payment (e.g. consumer, insurance, etc.)</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Payment</Table.Cell>
                                <Table.Cell>Payment Amount</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Payment Date</Table.Cell>
                                <Table.Cell>Date Payment Made</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Payment Status</Table.Cell>
                                <Table.Cell>Is Payment Rejected/Approved/Pending</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>PEN</Table.Cell>
                                <Table.Cell>Penalties</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>PB</Table.Cell>
                                <Table.Cell>Principal Balance</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>PBR</Table.Cell>
                                <Table.Cell>Principal Balance Referred (Enter New Account screen)</Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </Tab.Pane>
            )
        }
    },
    {
        menuItem: 'Q-Z',
        render: () => {
            return (
                <Tab.Pane attached={false}>
                    <Table inverted celled className="grey">
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Q - Z</Table.HeaderCell>
                                <Table.HeaderCell>Definition</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>Reason</Table.Cell>
                                <Table.Cell>Reason for Hold or Cancel</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Request Date</Table.Cell>
                                <Table.Cell>Date Our Request was Submitted</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Resolve</Table.Cell>
                                <Table.Cell>Resolve Action</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Role</Table.Cell>
                                <Table.Cell>The User’s Level of Access (User Roles screen)</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Role Creator</Table.Cell>
                                <Table.Cell>Who created this role? (User Roles screen)</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Role ID</Table.Cell>
                                <Table.Cell>Hierarchy of Role (User Roles screen)</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Role Name</Table.Cell>
                                <Table.Cell>Name of the Role (User Roles screen)</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Run</Table.Cell>
                                <Table.Cell>Use this Search Template</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Service Start</Table.Cell>
                                <Table.Cell>Date Services Began</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Service End</Table.Cell>
                                <Table.Cell>Date Services Ended</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Share?</Table.Cell>
                                <Table.Cell>Would you like to share this template?</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>SSN</Table.Cell>
                                <Table.Cell>Consumer’s Social Security Number</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Start Date</Table.Cell>
                                <Table.Cell>The date to *begin* the date range. (For Date Ranges)</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Status</Table.Cell>
                                <Table.Cell>The status of the account as of viewing.</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Status</Table.Cell>
                                <Table.Cell>Red dot for locked, and green dot for unlocked. (Users screen)</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Street Add</Table.Cell>
                                <Table.Cell>Consumer’s Street Address</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Submitted By</Table.Cell>
                                <Table.Cell>Name of the user that submitted the account. (For Batches)</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Title</Table.Cell>
                                <Table.Cell>The Name of Your Saved Search Report</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Row>
                                    <Table.Cell>Title</Table.Cell>
                                    <Table.Cell>User's business title (Users' screen)</Table.Cell>
                                </Table.Row>
                                <Table.Cell>Total</Table.Cell>
                                <Table.Cell>Current Total Due</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Upload</Table.Cell>
                                <Table.Cell>Click Browse Button to Upload</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>User Policy</Table.Cell>
                                <Table.Cell>Requested Clarification</Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </Tab.Pane>
            )
        }
    },
]
class Keyword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: 'React'
        };
    }

    componentDidMount() {
        this.props.addItem("helpFile", "acct_keyword-library.md");
        this.props.addItem("corporateSelect", false);
    }

    componentWillUnmount() {
        this.props.addItem("helpFile", null);
        this.props.addItem("corporateSelect", true);
    }
    render() {
        return (
            <div>
                <BreadcrumbCustom {...this.props} parent="My Account" child={[{ name: "Keyword Library", url: null }]} />
                <Grid className="g-bkgd">
                    <Grid.Row>
                        <Grid.Column>
                            <Tab menu={{ pointing: true }} panes={panes} />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}
export default Keyword;


// WEBPACK FOOTER //
// ./src/app/ui/administrations/Keyword.js